import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";


interface TabsV2Props
{
  tabIndex: number;
  handleChangeTab: (index: number) => void
}

export const TabsV2 = ({ tabIndex, handleChangeTab }: TabsV2Props) => {
  return (
    <div style={styles.row} >

      <ToggleButtonGroup value={tabIndex} exclusive onChange={(_, value) => handleChangeTab(value)} > 
        <ToggleButton style={styles.item} value={0} >MACD</ToggleButton>
        <ToggleButton style={styles.item} value={1} >EMA Crossover</ToggleButton>
        <ToggleButton style={styles.item} value={2} >Bollinger Bands</ToggleButton>
        <ToggleButton style={styles.item} value={3} >RSI</ToggleButton>
        <ToggleButton style={styles.item} value={4} >MFI</ToggleButton>
        <ToggleButton style={styles.item} value={5} >SMA</ToggleButton>
        <ToggleButton style={styles.item} value={6} >VWAP</ToggleButton>
        <ToggleButton style={styles.item} value={7} >Custom</ToggleButton>
        <ToggleButton style={styles.item} value={8} >Triple EMA</ToggleButton>
        <ToggleButton style={styles.item} value={9} >RSI Crossover</ToggleButton>
        <ToggleButton style={styles.item} value={10} >ADX</ToggleButton>
        <ToggleButton style={styles.item} value={11} >Triple RSI</ToggleButton>
        <ToggleButton style={styles.item} value={12} >Volume Profile</ToggleButton>
        <ToggleButton style={styles.item} value={13} >OBV</ToggleButton>
        <ToggleButton style={styles.item} value={14} >Market</ToggleButton>
      </ToggleButtonGroup>
      
    </div>
  )
}

const styles = {
  row: {
    display: "flex" as "flex",
    width: "100%",
    overflowX: "hidden" as "hidden",
    alignSelf: "center" as "center",
    justifyContent: "center" as "center",
  },
  item: {
    fontSize: 12,
    width: 79
  }
}